export default __webpack_public_path__ + "static/media/1760.70b6b512.png";